import React from 'react';
import { Card, Col, Row } from 'reactstrap';
import styles from './BuildPlan.module.css';
import cn from 'classnames';

const AddPlanCard = ({ plan }) => {
    // code/logic/vars here

    return (
        <Card className={cn(styles.addPlanCard, plan.featured && styles.featured)}>
            <Row>
                <Col
                    md='8'
                    className={styles.planCardLeft}
                >
                    <h3 className='h5'>{plan.title}</h3>
                    <p className='mb-2'>
                        Covers up to ${plan.coverageLimit} annually in repairs to the primary heating and cooling
                        system.
                    </p>
                    <p>
                        <a>View What's Covered</a>
                    </p>
                </Col>
                <Col
                    md='4'
                    className={cn(
                        styles.planCardRight,
                        styles.flex,
                        styles.alignCenter,
                        styles.justifyCenter,
                        styles.flexCol
                    )}
                >
                    <p>
                        <span className='h5'>${plan.price}.00</span>
                        /month
                    </p>
                    <button className={cn('btn-primary', styles.addButton)}>Add</button>
                </Col>
            </Row>
        </Card>
    );
};

export default AddPlanCard;
